import getFetchOptions from 'utils/getFetchOptions';

import { handleResponse } from '../utils';
import { AdministerPayoutRequest } from './payouts.types';

export const administerPayout = async (
  apiAprilBaseUri: string,
  payoutId: string,
  payload: AdministerPayoutRequest,
): Promise<object> => {
  const options = await getFetchOptions('PATCH', JSON.stringify(payload));
  return await fetch(`${apiAprilBaseUri}/transactions/enterprise/payouts/${payoutId}`, options).then(handleResponse);
};

export const reversePayout = async (apiBaseUri: string, merchantId: string, payoutId: string): Promise<object> => {
  const payload = {
    payoutId,
  };
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiBaseUri}/admin/merchants/${merchantId}/payout/reverse`, options).then(handleResponse);
};
